import React from 'react';
import moment from 'moment';
import { Link } from 'react-router';

const Footer = () => (
  <footer className="l-footer">
    <div className="row">
      <div className="columns small-16">
        <nav className="primary-nav">
          <div className="group">
            <div className="group-title">Categories</div>
            <ul>
              <li>
                <Link to="/logo-design/">Logo design</Link>
              </li>
              <li>
                <Link to="/naming-a-business-or-product/">Business names</Link>
              </li>
              <li>
                <Link to="/business-card-design/">Business card design</Link>
              </li>
              <li>
                <Link to="/website-design/">Website design</Link>
              </li>
              <li>
                <Link to="/package-graphics/">Package graphics</Link>
              </li>
              <li>
                <Link to="/packaging-design/">Packaging design</Link>
              </li>
              <li>
                <Link to="/product-design/">Product design</Link>
              </li>
              <li>
                <Link to="/categories/">Browse all categories</Link>
              </li>
            </ul>
          </div>
          <div className="group">
            <div className="group-title">Product</div>
            <ul>
              <li>
                <Link to="/how-it-works/">Design contests</Link>
              </li>
              <li>
                <Link to="/1to1-projects/">1-to-1 projects</Link>
              </li>
              <li>
                <Link to="/how-it-works/">How it Works</Link>
              </li>
              <li>
                <Link to="/pricing/">Pricing</Link>
              </li>
              <li>
                <Link to="/agencies/">Agencies</Link>
              </li>
              <li>
                <Link to="/help/">Help center</Link>
              </li>
              <li>
                <Link to="/guarantee/">Guarantee</Link>
              </li>
              <li>
                <Link to="/trust-and-security/">Trust and security</Link>
              </li>
            </ul>
          </div>
          <div className="group">
            <div className="group-title">Find a designer</div>
            <ul>
              <li>
                <Link to="/explore/creatives/">Graphic designer</Link>
              </li>
              <li>
                <Link to="/explore/creatives/?explore_creatives_filter_checkboxes_specializations.id=subcat_22%2Csubcat_26%2Csubcat_23%2Csubcat_24%2Csubcat_25">
                  Logo designer
                </Link>
              </li>
              <li>
                <Link to="/explore/creatives/?explore_creatives_filter_checkboxes_specializations.id=subcat_31%2Csubcat_32%2Csubcat_33%2Csubcat_42%2Csubcat_34%2Csubcat_35%2Csubcat_36%2Csubcat_37">
                  Web designer
                </Link>
              </li>
              <li>
                <Link to="/explore/creatives/?explore_creatives_filter_checkboxes_specializations.id=subcat_30
  ">
                  Product designer
                </Link>
              </li>
              <li>
                <Link to="/explore/creatives/?explore_creatives_filter_checkboxes_specializations.id=subcat_12%2Csubcat_13%2Csubcat_14%2Csubcat_15%2Csubcat_16%2Csubcat_17%2Csubcat_18">
                  Print designer
                </Link>
              </li>
              <li>
                <Link to="/explore/creatives/?explore_creatives_filter_checkboxes_specializations.id=subcat_100">
                  Packaging designer
                </Link>
              </li>
              <li>
                <Link to="/explore/creatives/">All freelance designers</Link>
              </li>
              <li>
                <Link to="/register/">Join as a designer or namer</Link>
              </li>
            </ul>
          </div>
          <div className="group">
            <div className="group-title">Resources</div>
            <ul>
              <li>
                <a href="/blog/">Blog</a> | <Link to="/books/">Books</Link>
              </li>
              <li>
                <a href="/resources/">Small business resources</a>
              </li>
              <li>
                <Link to="/agency-resources/">Agency resources</Link>
              </li>
              <li>
                <Link to="/blog/how-to-start-a-business/">How to start a business</Link>
              </li>
              <li>
                <a href="/blog/brand-identity/">Brand identity guide</a>
              </li>
              <li>
                <Link to="/how-to-write-a-business-plan/">How to write a business plan</Link>
              </li>
              <li>
                <Link to="/dba-state-requirements/">DBA state requirements</Link>
              </li>
              <li>
                <Link to="/marketing-psychology/">Marketing Psychology</Link>
              </li>
            </ul>
          </div>
          <div className="group">
            <div className="group-title">Company</div>
            <ul>
              <li>
                <Link to="/about-us/">About us</Link>
              </li>
              <li>
                <Link to="/help/contact/">Contact us</Link>
              </li>
              <li>
                <Link to="/reviews/">Reviews</Link>
              </li>
              <li>
                <Link to="/case-studies/">Case studies</Link>
              </li>
              <li>
                <Link to="/affiliates/">Become an affiliate</Link>
              </li>
              <li>
                <Link to="/partner-program/">Partner with crowdspring</Link>
              </li>
              <li>
                <Link to="/press/">Newsroom</Link>
              </li>
              <li>
                <Link to="/give-back/">Give back</Link>
              </li>
            </ul>
          </div>
        </nav>
        <nav className="secondary-nav">
          <div className="logo-wrapper">
            <Link to="/">
              <img src="https://images.crowdspring.com/blog/wp-content/uploads/2019/10/27125652/cs_logo-300x59.png"
                alt="crowdspring logo"/>
            </Link>
          </div>
          <ul className="social-media">
            <li>
              <a href="https://www.linkedin.com/company/crowdspring/">
                <i className="fa fa-linkedin" />
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/crowdspring/">
                <i className="fa fa-facebook" />
              </a>
            </li>
            <li>
              <a href="https://twitter.com/crowdspring/">
                <i className="fa fa-twitter" />
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/crowdspring/">
                <i className="fa fa-youtube" />
              </a>
            </li>
          </ul>
          <ul className="other">
            <li>
              <Link to="/privacy-policy/">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/user-agreement/">User Agreement</Link>
            </li>
            <li>© { moment().year() } All Rights Reserved</li>
          </ul>
        </nav>
      </div>
    </div>
  </footer>
);

export default Footer;
